import * as React from 'react';

import {
  Lang,
  Colors,

  Text,
} from '@bluecurrent/web-component-lib';

export default function Legenda({
  width,
}) {
  const { _ } = Lang.useTranslation();

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width,
          marginTop: 45,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          <Text
            fontSize="1em"
            color={Colors.DARK_GREY}
          >
            {`¹ ${_('marketPriceInclVat', { ns: 'ui' })}`}
          </Text>
          <Text
            fontSize="1em"
            color={Colors.DARK_GREY}
          >
            {`² ${_('marketPriceInclPurchaseFeeEnergyTaxVat', { ns: 'ui' })}`}
          </Text>
        </div>
      </div>
    </div>
  );
}
